export enum AztecScannerAction {
    SCAN = 'SCAN',
    CANCEL_SCANNING = 'CANCEL_SCANNING',
    CLOSE_APP = 'CLOSE_APP',
}
